/* Pehchaan Concierge — rule-based saree discovery assistant.
   No external AI call: every claim is either static brand copy written below
   (kept in sync with the real policy pages) or pulled live from the store's
   own /products.json at runtime, so it can never invent a product or price. */
(function () {
  'use strict';

  var root = document.getElementById('pch-concierge');
  if (!root) return;

  var launcher = document.getElementById('pch-concierge-launcher');
  var panel = document.getElementById('pch-concierge-panel');
  var closeBtn = document.getElementById('pch-concierge-close');
  var body = document.getElementById('pch-concierge-body');
  var form = document.getElementById('pch-concierge-form');
  var input = document.getElementById('pch-concierge-input');

  var contextEl = document.getElementById('pch-concierge-context');
  var context = {};
  try {
    context = JSON.parse(contextEl.textContent);
  } catch (e) {
    context = {};
  }

  var FABRIC_DICT = [
    { slug: 'ajrakh', label: 'Ajrakh', keywords: ['ajrak', 'ajrakh'] },
    { slug: 'tissue', label: 'Tissue', keywords: ['tissue'] },
    { slug: 'silk', label: 'Silk', keywords: ['silk'] },
    { slug: 'cotton', label: 'Cotton', keywords: ['cotton', 'khadi', 'madras', 'mul cotton', 'mulmul', 'kalamkari'] }
  ];

  var FABRIC_INFO = {
    ajrakh:
      'Ajrakh is a block-printing craft from Sindh and Kutch, especially the village of Ajrakhpur — carved wooden blocks and resist-dyeing, traditionally in deep indigo and crimson, built up into geometric patterns.',
    tissue:
      'Tissue is a light, delicate fabric with a soft, catching sheen and a fluid fall. It carries shine without needing heavy embellishment, which suits festive and evening occasions.',
    silk:
      'Our silks lean toward a raw, slubby texture — a crisp drape with a softer, less glossy sheen than a finished silk, and some pieces use batik, a wax-resist dyeing technique that builds up layered patterns.',
    cotton:
      'Our cottons include hand-spun khadi, Andhra kalamkari-printed mul cotton, and Chennai’s madras checks — light, breathable fabrics suited to everyday wear.',
    khadi:
      'Khadi is natural-fibre cloth, hand-spun and hand-woven — usually cotton, sometimes silk or wool. It has a slightly uneven, handmade texture, stays cool in warm weather, and carries a long history as a symbol of self-reliance.',
    kalamkari:
      'Kalamkari means “pen-craft.” It comes from Andhra Pradesh, in two GI-protected styles — Srikalahasti, hand-painted with a pen, and Machilipatnam, block-printed with vegetable dyes. Ours sits on a soft mul cotton base.',
    madras:
      'Madras is a light cotton with plaid-style checks, named after Chennai. Authentic madras shows the same pattern on both sides, with small natural slubs from short-staple cotton.',
    satin: 'Satin is a weave rather than a fibre — it gives a smooth, lightly lustrous finish on top of whatever it’s printed or woven with.'
  };

  var BUDGET_OPTIONS = [
    { key: 'under-2000', label: 'Under ₹2,000', min: 0, max: 2000 },
    { key: '2000-3000', label: '₹2,000–₹3,000', min: 2000, max: 3000 },
    { key: '3000-4000', label: '₹3,000–₹4,000', min: 3000, max: 4000 },
    { key: '4000-plus', label: '₹4,000+', min: 4000, max: Infinity }
  ];

  var answers = { occasion: null, style: null, fabricSlug: null, fabricLabel: null, budgetKey: null };
  var productsPromise = null;
  var panelOpen = false;
  var greeted = false;

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatPrice(amount) {
    var n = Math.round(Number(amount));
    return '₹' + n.toLocaleString('en-IN');
  }

  function scrollToEnd() {
    body.scrollTop = body.scrollHeight;
  }

  function addMessage(role, html) {
    var el = document.createElement('div');
    el.className = 'pch-cc-msg pch-cc-msg--' + role;
    el.innerHTML = html;
    body.appendChild(el);
    scrollToEnd();
    return el;
  }

  function addQuickActions(options) {
    var wrap = document.createElement('div');
    wrap.className = 'pch-cc-quick';
    options.forEach(function (opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pch-cc-quick__btn';
      btn.textContent = opt.label;
      btn.addEventListener('click', function () {
        wrap.remove();
        addMessage('user', escapeHtml(opt.label));
        opt.onClick();
      });
      wrap.appendChild(btn);
    });
    body.appendChild(wrap);
    scrollToEnd();
    return wrap;
  }

  function showTyping(callback, delay) {
    var el = document.createElement('div');
    el.className = 'pch-cc-typing';
    el.innerHTML = '<span></span><span></span><span></span>';
    body.appendChild(el);
    scrollToEnd();
    window.setTimeout(function () {
      el.remove();
      callback();
    }, delay || 420);
  }

  function addProductCard(product, reason) {
    var image = product.images && product.images[0] ? product.images[0].src : null;
    var price = product.variants && product.variants.length ? Math.min.apply(null, product.variants.map(function (v) { return Number(v.price); })) : null;
    var card = document.createElement('a');
    card.className = 'pch-cc-product';
    card.href = '/products/' + product.handle;

    var mediaHtml = image
      ? '<img src="' + image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
      : '';

    card.innerHTML =
      '<span class="pch-cc-product__media">' + mediaHtml + '</span>' +
      '<span class="pch-cc-product__info">' +
      '<span class="pch-cc-product__name">' + escapeHtml(product.title) + '</span>' +
      (price != null ? '<span class="pch-cc-product__price">' + formatPrice(price) + '</span>' : '') +
      '<span class="pch-cc-product__reason">' + escapeHtml(reason) + '</span>' +
      '<span class="pch-cc-product__cta">View Saree</span>' +
      '</span>';
    body.appendChild(card);
    scrollToEnd();
  }

  function loadProducts() {
    if (!productsPromise) {
      productsPromise = fetch('/products.json?limit=250')
        .then(function (r) {
          if (!r.ok) throw new Error('bad response');
          return r.json();
        })
        .then(function (data) {
          return data.products || [];
        })
        .catch(function () {
          return null;
        });
    }
    return productsPromise;
  }

  function fabricSlugForTitle(title) {
    var lower = title.toLowerCase();
    for (var i = 0; i < FABRIC_DICT.length; i++) {
      var entry = FABRIC_DICT[i];
      for (var j = 0; j < entry.keywords.length; j++) {
        if (lower.indexOf(entry.keywords[j]) !== -1) return entry.slug;
      }
    }
    return null;
  }

  function minPrice(product) {
    return Math.min.apply(null, product.variants.map(function (v) { return Number(v.price); }));
  }

  function fabricCharacterPhrase(slug) {
    switch (slug) {
      case 'tissue':
        return 'a delicate shine that reads festive without trying too hard';
      case 'silk':
        return 'a soft, understated sheen with real body to the drape';
      case 'ajrakh':
        return 'traditional block-printed pattern with a lot of quiet presence';
      case 'cotton':
        return 'light, breathable and easy for everyday wear';
      default:
        return 'a character that feels considered rather than loud';
    }
  }

  function buildReason(product, fabricSlug) {
    var bits = [];
    var pSlug = fabricSlugForTitle(product.title);
    if (pSlug) bits.push('This one leans toward ' + fabricCharacterPhrase(pSlug) + '.');
    if (answers.style) bits.push('Given you mentioned wanting something ' + answers.style.toLowerCase() + ', it felt worth showing you.');
    if (!bits.length) bits.push('It sits within what you were looking for.');
    return bits.join(' ');
  }

  function recommend(options) {
    options = options || {};
    showTyping(function () {
      loadProducts().then(function (products) {
        if (!products) {
          addMessage('assistant', '<p>I’m having a little trouble reaching the catalogue right now. You can still explore the collection below, or reach the Pehchaan team directly.</p>');
          addQuickActions([
            { label: 'Explore the collection', onClick: function () { window.location.href = context.collectionUrl || '/collections/all'; } },
            { label: 'Talk to the Pehchaan team', onClick: handoff }
          ]);
          return;
        }

        var pool = products.filter(function (p) { return p.variants && p.variants.some(function (v) { return v.available; }); });

        if (options.excludeHandle) {
          pool = pool.filter(function (p) { return p.handle !== options.excludeHandle; });
        }

        var fabricSlug = options.fabricSlug;
        var budget = options.budgetKey ? BUDGET_OPTIONS.filter(function (b) { return b.key === options.budgetKey; })[0] : null;

        var filtered = pool;
        var relaxedNote = '';

        if (fabricSlug) {
          var byFabric = filtered.filter(function (p) { return fabricSlugForTitle(p.title) === fabricSlug; });
          if (byFabric.length) filtered = byFabric;
        }

        if (budget) {
          var byBudget = filtered.filter(function (p) {
            var price = minPrice(p);
            return price >= budget.min && price < budget.max;
          });
          if (byBudget.length) {
            filtered = byBudget;
          } else {
            relaxedNote = 'I don’t have one in that exact range just now, but here’s what comes closest:';
          }
        }

        filtered.sort(function (a, b) { return minPrice(a) - minPrice(b); });
        var picks = filtered.slice(0, 2);

        if (!picks.length) {
          addMessage('assistant', '<p>I couldn’t find a close match for that combination right now. Let me show you the full collection instead.</p>');
          addQuickActions([
            { label: 'Explore the collection', onClick: function () { window.location.href = context.collectionUrl || '/collections/all'; } },
            { label: 'Talk to the Pehchaan team', onClick: handoff }
          ]);
          return;
        }

        var intro = relaxedNote || 'Based on what you’re looking for, these feel like a good match:';
        addMessage('assistant', '<p>' + intro + '</p>');
        picks.forEach(function (p) { addProductCard(p, buildReason(p, fabricSlug)); });

        addQuickActions([
          { label: 'Explore the collection', onClick: function () { window.location.href = context.collectionUrl || '/collections/all'; } },
          { label: 'Start over', onClick: resetFlow }
        ]);
      });
    }, 500);
  }

  function resetFlow() {
    answers = { occasion: null, style: null, fabricSlug: null, fabricLabel: null, budgetKey: null };
    askOccasion();
  }

  function askOccasion() {
    addMessage('assistant', '<p>What are you dressing for?</p>');
    addQuickActions([
      { label: 'Everyday', onClick: function () { answers.occasion = 'everyday'; askStyle(); } },
      { label: 'Work', onClick: function () { answers.occasion = 'work'; askStyle(); } },
      { label: 'Festive', onClick: function () { answers.occasion = 'festive'; askStyle(); } },
      { label: 'Wedding', onClick: function () { answers.occasion = 'wedding'; askStyle(); } },
      { label: 'Evening', onClick: function () { answers.occasion = 'evening'; askStyle(); } },
      { label: 'Just because', onClick: function () { answers.occasion = 'just because'; askStyle(); } }
    ]);
  }

  function askStyle() {
    showTyping(function () {
      addMessage('assistant', '<p>And what kind of feeling are you looking for?</p>');
      addQuickActions([
        { label: 'Minimal', onClick: function () { answers.style = 'minimal'; askFabric(); } },
        { label: 'Elegant', onClick: function () { answers.style = 'elegant'; askFabric(); } },
        { label: 'Traditional', onClick: function () { answers.style = 'traditional'; askFabric(); } },
        { label: 'Statement', onClick: function () { answers.style = 'statement'; askFabric(); } },
        { label: 'Soft & effortless', onClick: function () { answers.style = 'soft & effortless'; askFabric(); } }
      ]);
    });
  }

  function askFabric() {
    showTyping(function () {
      addMessage('assistant', '<p>Do you have a preferred fabric?</p>');
      addQuickActions([
        { label: 'Cotton', onClick: function () { answers.fabricSlug = 'cotton'; answers.fabricLabel = 'Cotton'; askBudget(); } },
        { label: 'Silk', onClick: function () { answers.fabricSlug = 'silk'; answers.fabricLabel = 'Silk'; askBudget(); } },
        { label: 'Tissue', onClick: function () { answers.fabricSlug = 'tissue'; answers.fabricLabel = 'Tissue'; askBudget(); } },
        { label: 'Ajrakh', onClick: function () { answers.fabricSlug = 'ajrakh'; answers.fabricLabel = 'Ajrakh'; askBudget(); } },
        { label: 'Not sure', onClick: function () { answers.fabricSlug = null; answers.fabricLabel = null; askBudget(); } }
      ]);
    });
  }

  function askBudget() {
    showTyping(function () {
      addMessage('assistant', '<p>And what’s your approximate budget?</p>');
      addQuickActions(BUDGET_OPTIONS.map(function (b) {
        return { label: b.label, onClick: function () { answers.budgetKey = b.key; recommend({ fabricSlug: answers.fabricSlug, budgetKey: answers.budgetKey }); } };
      }));
    });
  }

  function answerFabricQuestion(slug, label) {
    showTyping(function () {
      var info = FABRIC_INFO[slug] || 'I don’t have detailed information on that yet, but I can show you what’s available in it.';
      addMessage('assistant', '<p>' + info + '</p>');
      addQuickActions([
        { label: 'Show me ' + (label || 'these') + ' sarees', onClick: function () { recommend({ fabricSlug: slug }); } },
        { label: 'Help me choose', onClick: askOccasion }
      ]);
    });
  }

  function answerShipping() {
    showTyping(function () {
      addMessage(
        'assistant',
        '<p>Orders are typically processed in 1–3 business days, with delivery after dispatch taking a further 4–7 business days within India. Remote areas may need a little more time.</p>'
      );
      addQuickActions([
        { label: 'Read the full policy', onClick: function () { window.location.href = context.shippingUrl || '/pages/shipping-delivery'; } }
      ]);
    });
  }

  function answerReturns() {
    showTyping(function () {
      addMessage(
        'assistant',
        '<p>If something isn’t right, you can reach out within 7 days of delivery with your order number and the reason for the return.</p>'
      );
      addQuickActions([
        { label: 'Read the full policy', onClick: function () { window.location.href = context.returnsUrl || '/pages/returns-exchanges'; } }
      ]);
    });
  }

  function answerSizing() {
    showTyping(function () {
      addMessage(
        'assistant',
        '<p>Fit and blouse details vary by saree, so I’d point you to the individual product page — it will show what’s included and any sizing specifics for that piece.</p>'
      );
      addQuickActions([
        { label: 'Read our FAQs', onClick: function () { window.location.href = context.faqUrl || '/pages/faqs'; } },
        { label: 'Talk to the Pehchaan team', onClick: handoff }
      ]);
    });
  }

  function answerStyling() {
    showTyping(function () {
      var occasion = answers.occasion;
      var tip;
      if (occasion === 'wedding') {
        tip = 'For a wedding, I’d let the saree stay the focus — statement earrings, a clean blouse silhouette and a structured clutch.';
      } else if (occasion === 'festive' || occasion === 'evening') {
        tip = 'For something festive, a touch more jewellery and a well-fitted blouse carry it well, without needing to compete with the saree itself.';
      } else if (occasion === 'work') {
        tip = 'For work, I’d keep it simple — minimal jewellery, a comfortable drape, and shoes you can actually walk in.';
      } else {
        tip = 'I’d keep the accessories quiet and let the drape and print do the talking — a clean blouse and simple jewellery usually work best.';
      }
      addMessage('assistant', '<p>' + tip + ' If you’d like, I can also show you a few sarees to go with it.</p>');
      addQuickActions([
        { label: 'Show me sarees', onClick: function () { recommend({ fabricSlug: answers.fabricSlug }); } },
        { label: 'Talk to the Pehchaan team', onClick: handoff }
      ]);
    });
  }

  function answerIsFestive(productTitle) {
    showTyping(function () {
      var slug = fabricSlugForTitle(productTitle || '');
      var verdict;
      if (slug === 'tissue' || slug === 'silk') {
        verdict = 'It leans festive — the sheen catches light in a way that suits evening and celebratory occasions.';
      } else if (slug === 'ajrakh') {
        verdict = 'It can go either way — the block-printed pattern has enough presence for a festive occasion, but it reads easy enough for everyday wear too.';
      } else if (slug === 'cotton') {
        verdict = 'It leans more everyday than festive — light and breathable, better suited to daytime or casual occasions.';
      } else {
        verdict = 'It depends a little on how it’s styled — I’d be happy to help you think that through.';
      }
      addMessage('assistant', '<p>' + verdict + '</p>');
      addQuickActions([
        { label: 'How can I style it?', onClick: answerStyling },
        { label: 'Show me similar sarees', onClick: function () { recommend({ fabricSlug: slug }); } }
      ]);
    });
  }

  function fallback(userText) {
    showTyping(function () {
      addMessage(
        'assistant',
        '<p>I’m not able to confirm that from the information I have. You can reach the Pehchaan team directly, or I can help you find a saree instead.</p>'
      );
      addQuickActions([
        { label: 'Help me choose', onClick: askOccasion },
        { label: 'Talk to the Pehchaan team', onClick: handoff }
      ]);
    });
  }

  function handoff() {
    showTyping(function () {
      addMessage('assistant', '<p>Of course — you can reach the Pehchaan team directly on WhatsApp and we’ll pick it up from there.</p>');
      addQuickActions([
        { label: 'Message on WhatsApp', onClick: function () { window.open(context.whatsapp || 'https://wa.me/919767359877', '_blank', 'noopener'); } }
      ]);
    });
  }

  function handleFreeText(raw) {
    var text = raw.toLowerCase();

    var specificKey = Object.keys(FABRIC_INFO).filter(function (k) { return text.indexOf(k) !== -1; })[0];
    if (specificKey) { answerFabricQuestion(specificKey, specificKey); return; }

    for (var i = 0; i < FABRIC_DICT.length; i++) {
      var entry = FABRIC_DICT[i];
      for (var j = 0; j < entry.keywords.length; j++) {
        if (text.indexOf(entry.keywords[j]) !== -1) {
          answerFabricQuestion(entry.slug, entry.label);
          return;
        }
      }
    }
    if (/ship|deliver|dispatch/.test(text)) { answerShipping(); return; }
    if (/return|exchange|refund/.test(text)) { answerReturns(); return; }
    if (/size|sizing|\bfit\b|blouse|length/.test(text)) { answerSizing(); return; }
    if (/contact|human|talk to|whatsapp|team|support/.test(text)) { handoff(); return; }
    if (/similar|like this|more like/.test(text) && context.product) {
      showTyping(function () {
        addMessage('assistant', '<p>Here are a few that feel similar:</p>');
        recommend({ fabricSlug: fabricSlugForTitle(context.product.title), excludeHandle: (context.product.url || '').split('/').pop() });
      });
      return;
    }
    if (/style|wear|pair|accessor/.test(text)) { answerStyling(); return; }
    if (/choose|help me|recommend|suggest/.test(text)) { askOccasion(); return; }
    if (/budget|under|price|rupee|₹/.test(text)) {
      var match = text.match(/(\d{3,6})/);
      if (match) {
        var amount = Number(match[0]);
        var bracket = BUDGET_OPTIONS.filter(function (b) { return amount >= b.min && amount < b.max; })[0] || BUDGET_OPTIONS[BUDGET_OPTIONS.length - 1];
        showTyping(function () { recommend({ fabricSlug: answers.fabricSlug, budgetKey: bracket.key }); });
        return;
      }
      askBudget();
      return;
    }
    fallback(raw);
  }

  function greet() {
    if (greeted) return;
    greeted = true;

    if (context.template === 'product' && context.product) {
      addMessage('assistant', '<p>You’re looking at the ' + escapeHtml(context.product.title) + '.</p>');
      addQuickActions([
        { label: 'Tell me about this saree', onClick: function () { answerFabricQuestion(fabricSlugForTitle(context.product.title), null); } },
        { label: 'How can I style it?', onClick: answerStyling },
        { label: 'Is it festive?', onClick: function () { answerIsFestive(context.product.title); } },
        { label: 'Show me similar sarees', onClick: function () { recommend({ fabricSlug: fabricSlugForTitle(context.product.title), excludeHandle: (context.product.url || '').split('/').pop() }); } }
      ]);
      return;
    }

    addMessage(
      'assistant',
      '<p>Namaste. Welcome to पहचान.</p><p>Looking for something specific, or would you like me to help you find a saree that feels like you?</p>'
    );
    addQuickActions([
      { label: 'Help me choose', onClick: askOccasion },
      { label: 'Shop by occasion', onClick: askOccasion },
      { label: 'Explore fabrics', onClick: function () { showTyping(function () {
          addMessage('assistant', '<p>Which fabric would you like to know about?</p>');
          addQuickActions([
            { label: 'Cotton', onClick: function () { answerFabricQuestion('cotton', 'Cotton'); } },
            { label: 'Silk', onClick: function () { answerFabricQuestion('silk', 'Silk'); } },
            { label: 'Tissue', onClick: function () { answerFabricQuestion('tissue', 'Tissue'); } },
            { label: 'Ajrakh', onClick: function () { answerFabricQuestion('ajrakh', 'Ajrakh'); } }
          ]);
        }); } },
      { label: 'Find by budget', onClick: askBudget },
      { label: 'Explore the collection', onClick: function () { window.location.href = context.collectionUrl || '/collections/all'; } }
    ]);
  }

  function openPanel() {
    panel.hidden = false;
    window.requestAnimationFrame(function () {
      panel.setAttribute('data-open', '');
    });
    launcher.setAttribute('aria-expanded', 'true');
    panelOpen = true;
    greet();
    window.setTimeout(function () { input.focus(); }, 220);
  }

  function closePanel() {
    panel.removeAttribute('data-open');
    launcher.setAttribute('aria-expanded', 'false');
    panelOpen = false;
    window.setTimeout(function () {
      if (!panelOpen) panel.hidden = true;
    }, 220);
    launcher.focus();
  }

  launcher.addEventListener('click', function () {
    if (panelOpen) {
      closePanel();
    } else {
      openPanel();
    }
  });

  closeBtn.addEventListener('click', closePanel);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panelOpen) closePanel();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var value = input.value.trim();
    if (!value) return;
    addMessage('user', escapeHtml(value));
    input.value = '';
    handleFreeText(value);
  });
})();
